export default __webpack_public_path__ + "static/media/ShiningStar.dad49497.svg";